
import MaintenanceIndex from '../components/maintenances/MaintenanceIndex.vue';
import Vue from 'vue';

Vue.component('maintenance-index', MaintenanceIndex);

export default Vue.extend({});
